module.exports = __webpack_public_path__ + "img/daiweipeiyao_image_zhuyi.3cfd665c.png";